import { Link } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { ArrowUpRight, Calendar, Clock } from "lucide-react";
import { articles, images } from "@/mock/mock";

export default function Insights() {
  const [featured, ...rest] = articles;
  return (
    <>
      <PageHeader
        eyebrow="Insights"
        title="Security insights & articles"
        subtitle="Practical perspectives on managed security, AI governance, forensics and compliance from our Halifax team."
      />

      <section className="py-20">
        <div className="mx-auto max-w-7xl px-6">
          {/* featured */}
          <Reveal>
            <Link to={`/insights/${featured.slug}`} className="group grid lg:grid-cols-2 gap-8 rounded-3xl border border-white/10 bg-brand-navy2/60 overflow-hidden card-hover">
              <div className="relative h-64 lg:h-auto overflow-hidden">
                <img src={images[featured.image]} alt={featured.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy2 to-transparent lg:bg-gradient-to-r" />
                <span className="absolute top-4 left-4 rounded-full bg-brand-lime px-3 py-1 text-[11px] font-semibold text-brand-navy">Featured</span>
              </div>
              <div className="p-8 lg:p-10 flex flex-col justify-center">
                <span className="text-sm font-semibold uppercase tracking-wider text-brand-lime">{featured.category}</span>
                <h2 className="mt-3 font-display text-2xl lg:text-3xl font-bold text-white group-hover:text-brand-lime transition-colors">{featured.title}</h2>
                <p className="mt-4 text-slate-400">{featured.excerpt}</p>
                <div className="mt-6 flex items-center gap-5 text-xs text-slate-400">
                  <span className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5 text-brand-lime" /> {featured.date}</span>
                  <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5 text-brand-lime" /> {featured.readTime}</span>
                </div>
                <span className="mt-6 inline-flex items-center gap-1 font-medium text-brand-lime">Read article <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" /></span>
              </div>
            </Link>
          </Reveal>

          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {rest.map((a, i) => (
              <Reveal key={a.slug} delay={(i % 3) * 80}>
                <Link to={`/insights/${a.slug}`} className="group block h-full rounded-2xl border border-white/10 bg-brand-navy2/60 overflow-hidden card-hover">
                  <div className="relative h-44 overflow-hidden">
                    <img src={images[a.image]} alt={a.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <span className="absolute top-3 left-3 rounded-full bg-white/10 px-3 py-1 text-[11px] font-medium text-brand-lime backdrop-blur">{a.category}</span>
                  </div>
                  <div className="p-6">
                    <h3 className="font-display text-lg font-semibold text-white group-hover:text-brand-lime transition-colors">{a.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-400 line-clamp-3">{a.excerpt}</p>
                    <div className="mt-4 flex items-center gap-4 text-xs text-slate-400">
                      <span className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5 text-brand-lime" /> {a.date}</span>
                      <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5 text-brand-lime" /> {a.readTime}</span>
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
